export default "__VITE_ASSET__i2Q6pvkC__"